import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ServiceGuard } from '../_guards/service.guard';
import { EnvSpecific } from '../environs/models/env-specific';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class GiftCardErrorService {

  constructor(private readonly _http: Http, private readonly _serviceGuard: ServiceGuard) { }

  getContactId(envSpecific: EnvSpecific, hashCode: string) {
    return this._http
      .get(envSpecific.orionServiceUrl + '/contacts/v2/gdpr/contactHash?hashCode=' + hashCode, {
        headers: this._serviceGuard.authJsonHeaders()
      })
      .map((response: Response) => response.json())
      .do(d => console.log('All: ' + JSON.stringify(d)));
  }
}
